export interface CoinmakersVaultAsset {
  readonly key: string;
  readonly path: string;
  readonly width: number;
  readonly height: number;
  readonly kind: 'image';
  readonly alpha: boolean;
  readonly required: true;
}

const ROOT = 'assets/number-kingdom/coinmakers-vault';
const image = (
  key: string,
  path: string,
  width: number,
  height: number,
  alpha: boolean,
): CoinmakersVaultAsset => ({ key, path: `${ROOT}/${path}`, width, height, kind: 'image', alpha, required: true });

export const COINMAKERS_VAULT_ASSETS = {
  dormant: image('coinmakers-vault-dormant', 'backgrounds/coinmakers-vault-dormant.png', 1280, 720, false),
  restored: image('coinmakers-vault-restored', 'backgrounds/coinmakers-vault-restored.png', 1280, 720, false),
  oneCent: image('coinmakers-vault-one-cent', 'interactives/one-cent.png', 256, 256, true),
  fiveCent: image('coinmakers-vault-five-cent', 'interactives/five-cent.png', 256, 256, true),
  tenCent: image('coinmakers-vault-ten-cent', 'interactives/ten-cent.png', 256, 256, true),
  twentyFiveCent: image('coinmakers-vault-twenty-five-cent', 'interactives/twenty-five-cent.png', 256, 256, true),
} as const;

export const COINMAKERS_VAULT_ASSET_LIST = Object.values(COINMAKERS_VAULT_ASSETS);
export const COINMAKERS_VAULT_PRODUCTION_READY = true;

export function preloadCoinmakersVaultAssets(scene: Phaser.Scene) {
  COINMAKERS_VAULT_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingCoinmakersVaultAssets(textures: Phaser.Textures.TextureManager) {
  return COINMAKERS_VAULT_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}

export function canEnterCoinmakersVault(textures: Phaser.Textures.TextureManager) {
  return COINMAKERS_VAULT_PRODUCTION_READY
    && getMissingCoinmakersVaultAssets(textures).length === 0;
}
